import React, { useState } from 'react'
import useAuthStore from '../stores/useAuthStore'
import { Button, Form } from 'react-bootstrap'

export default function LoginForm() {
    const [email, setEmail] = useState<string>('')
    const [password, setPassword] = useState<string>('')

    // Selectors automatically inherit types from the store definition
    const login = useAuthStore((state) => state.login)
    const isLoading = useAuthStore((state) => state.isLoading)
    const error = useAuthStore((state) => state.error)

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        // TypeScript will error out if credentials don't match LoginCredentials
        login({ email, password })
    }

    return (<>

        {/* Form Container */}
        <Form onSubmit={handleSubmit} className="login-form-container d-flex flex-column align-items-center w-100">

            {/* Username Input Container */}
            <div className="input-group-custom mb-3">
                <Form.Control
                    type="text"
                    placeholder="Email"
                    className="custom-input"
          defaultValue={email}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}

                />
            </div>

            {/* Password Input Container */}
            <div className="input-group-custom mb-3">
                <Form.Control
                    type="password"
                    placeholder="password"
                    className="custom-input"
                    defaultValue={password}

                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                    
                />
            </div>

            {/* Star Enter Button Area */}
            <div className="star-button-wrapper align-self-end mt-2">
                <Button type="submit" className="star-btn">
                    <span className="star-text">Enter</span>
                </Button>
            </div>

        </Form>

    </>)

    return (
        <Form onSubmit={handleSubmit}>
            {/* <form onSubmit={handleSubmit}> */}
            <h2>Login</h2>
            {error && <p style={{ color: 'red' }}>{error}</p>}

            <input
                type="email"
                value={email}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                placeholder="Email"
                required
            />
            <input
                type="password"
                value={password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                placeholder="Password"
                required
            />

            <button type="submit" disabled={isLoading}>
                {isLoading ? 'Logging in...' : 'Submit'}
            </button>
            {/* </form> */}
        </Form>

    )
}
